import Layout from "../components/Common/Layouts";
import DiffViewerComponent from "../components/DiffViewer";

const DiffViewer = () => {
  return (
    <Layout>
      <DiffViewerComponent />
    </Layout>
  );
};

export default DiffViewer;
